import {useEffect, RefObject} from 'react';

export type clickOutsideEventListener = (
  event: MouseEvent | TouchEvent
) => void;

export const useClickOutside = (
  ref: RefObject<HTMLElement>,
  callback: clickOutsideEventListener
) => {
  const handleClickOutside: clickOutsideEventListener = (event) => {
    if (ref.current && !ref.current.contains(event.target as Node)) {
      callback(event);
    }
  };

  useEffect(() => {
    const handleOutsideClick = handleClickOutside;
    document.addEventListener('click', handleOutsideClick);
    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, [ref, callback, handleClickOutside]);
};
